export const TEXTFIELD_TYPES = {
  CURRENCY: "Currency",
};
